/**
* Okendo Reviews Custom Page Transition Override
* 
* This script prevents the Motion theme's page transition system from interfering
* with Okendo Reviews interactive elements, specifically media strip items.
* 
* The theme normally intercepts all anchor clicks to add a page transition
* effect, but this interferes with Okendo's interactive review media.
* 
* Usage: Include this script *before* the main theme.js file
*/

(function() {
  'use strict';
  
  /**
   * Ensure Okendo media links are excluded from theme page transitions
   * by adding the `js-no-transition` class. This lets Okendo's own
   * click handlers open the modal instead of the theme intercepting
   * and navigating directly to the image URL.
   */
  function markOkendoMediaLinks(root) {
    /**
     * We target both public and JS hook classes used by Okendo for
     * media strip items. We only add the class if it's missing.
     */
    const selector = 'a.okeReviews-mediaStrip-item, a.js-okeReviews-mediaStrip-item';
    const scope = root && root.querySelectorAll ? root : document;
    const anchors = scope.querySelectorAll(selector);
    anchors.forEach(function(anchor) {
      if (!anchor.classList.contains('js-no-transition')) {
        anchor.classList.add('js-no-transition');
      }
    });
  }
  
  // Initialize when DOM is ready
  function initOkendoCustomization() {
    markOkendoMediaLinks(document);
    interceptOkendoMediaClicks();
  }
  
  /**
   * Intercept clicks on Okendo media anchors in the capture phase and
   * prevent the browser from navigating to the image URL. We do not stop
   * propagation so that Okendo's own handlers can still open the modal.
   */
  function interceptOkendoMediaClicks() {
    const selector = 'a.okeReviews-mediaStrip-item, a.js-okeReviews-mediaStrip-item';
    document.addEventListener('click', function(evt) {
      var target = evt.target;
      if (!target) return;
      var anchor = target.closest && target.closest('a');
      if (!anchor) return;
      if (!anchor.matches(selector)) return;
      // Allow meta/ctrl clicks to open in new tab as normal
      if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.button && evt.button !== 0) return;
      // Critical: prevent default navigation so Okendo modal can take over
      evt.preventDefault();
      // Do NOT stop propagation; Okendo's handlers should still receive the event
    }, true); // capture phase to run before any bubbling handlers
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOkendoCustomization);
  } else {
    initOkendoCustomization();
  }
  
  // Also run when new content is added (for dynamic content)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Apply class to any newly added Okendo media links
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.matches && (node.matches('a.okeReviews-mediaStrip-item') || node.matches('a.js-okeReviews-mediaStrip-item'))) {
              markOkendoMediaLinks(node);
            }
            // Also check for Okendo anchors within the added node
            markOkendoMediaLinks(node);
          }
        });
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  })();
  
  
  